import styled from 'styled-components';
export const Wrapper = styled.form ``;
export const Title = styled.span `
  font: var(--heading-four-font);
  color: var(--primary-darker);
  display: block;
  padding-top: 1.6rem;
  margin-top: 0.2rem;
  border-top: 0.1rem solid var(--border);
`;
export const Copy = styled.span `
  font: var(--paragraph-medium-font);
  display: block;
  margin-top: 0.5rem;
`;
export default {
    Wrapper,
    Title,
    Copy,
};
